import { useEffect } from 'react';

import { isAuthenticated } from 'actions/user';
import { postMessageToMobileApp } from 'components/app/helpers';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { userSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

const useSendUserAuthorizedMessageToMobile = () => {
  const user = useAppSelector(state => userSelector(state));
  const isLoggedIn = isAuthenticated(user);
  const token = user?.token;

  useEffect(() => {
    if (isLoggedIn) {
      postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.USER_AUTHORIZED, {
        user,
      });
    }
    // Only need to run on token change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, token]);
};

export { useSendUserAuthorizedMessageToMobile };
